import { SORT_ORDER } from '../constants';

const PER_PAGE = 100;

interface BuildOptionsParams {
  page: number;
  from?: number;
  to?: number;
  runId?: string;
  severity?: string;
}

export function buildOptionsForV1(
  params: BuildOptionsParams,
  exploreFlowLogs: boolean,
  sortOrder: string = SORT_ORDER.NEWEST,
) {
  const { page, from, runId, to, severity } = params;

  const options: any = {
    runId,
    page,
    per_page: PER_PAGE,
    from,
    to,
    severity,
    sort: sortOrder,
  };

  // from === to strips a valid single-day selection; not fixing, V1 is going away soon.
  if (exploreFlowLogs && (options.from === options.to || !options.from || !options.to)) {
    delete options.to;
    delete options.from;
  }

  if (!severity) delete options.severity;

  return options;
}
